import { render, staticRenderFns } from "./MoveTaskList.vue?vue&type=template&id=4d47ae28"
import script from "./MoveTaskList.vue?vue&type=script&lang=js"
export * from "./MoveTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports